import dynamic from 'next/dynamic';

export { appInsight, disableTelemetry, SeverityLevel } from './AppInsight';
export { appInsightPageLoad, appInsightScommessaReady } from './utils';
export const AppInsightScript = dynamic(
  () => import('common/components/appInsight/AppInsightScript').then((data) => data.AppInsightScript),
  { ssr: false }
);
